import { useAddAlert } from "@/hooks/useAddAlert";

export const useCanvasSave = ({canvasState, canvasRef, saveImageParams}) => {
  const { setIsSaving } = canvasState;
  const addAlert = useAddAlert();

  const saveImage = async (saveCallback) => {
    setIsSaving(true);
    if(saveImageParams.initialText){
      addAlert({ title: saveImageParams.initialText });
    }
    const dataURL = canvasRef.current.toDataURL('image/png');
    const blob = await (await fetch(dataURL)).blob();
    
    try {
      await saveCallback(blob);
      if(saveImageParams.successText){
        addAlert({ text: saveImageParams.successText });
      }
    } catch (error) {
      addAlert({ title: 'Ошибка', text: 'Не удалось сохранить изображение', type: 'error' });
    } finally {
      setIsSaving(false);
    }
  };

  return { saveImage };
};